import { TextTag } from "../../../Tags/Text";
import { TagSizes } from "../../../Tags/utils/theme";
import { Color } from "../../../atoms/Badge";

export enum ReservationStatus {
  PAYMENT_COMPLETED = "예약신청",
  RESERVATION_COMPLETED = "예약확정",
  COMPLETED = "작업완료",
  CANCELED_ORDER = "예약취소",
}

export type ReservationStatusType = keyof typeof ReservationStatus;

/**
 * 주문상태별 컬러
 */
export const reservationStatusColor: {
  [key: string]: Color;
} = {
  PAYMENT_COMPLETED: "yellow",
  RESERVATION_COMPLETED: "green",
  COMPLETED: "purple",
  CANCELED_ORDER: "gray",
};

interface ReservationStatusTagProps {
  value: ReservationStatusType;
  size?: TagSizes;
}

/**
 * 예약상태 태그
 * @param value
 * @returns
 */
export const ReservationStatusTag: React.FC<ReservationStatusTagProps> = ({
  value,
  size,
}) => {
  return (
    <>
      {ReservationStatus[value] ? (
        <TextTag colors={reservationStatusColor[value] as Color} size={size}>
          {ReservationStatus[value]}
        </TextTag>
      ) : (
        "-"
      )}
    </>
  );
};
